import AlwaysTouchOffers from '../AlwaysTouchOffers';
import OffersList from '../OffersList';
import React from 'react';
import ContactLess from '../ContactLess';
import McGifts from '../McGifts';
import HappyATB from "../HappyATB";
import UnderSunAquiring from "../UnderSunAquiring";
import DoubleSalary from "../DoubleSalary";
import UnitedCountry from "../UnitedCountry";

export default function template() {
    let Component = null,
        { match = {} } = this.props;
    if (match.params && match.params.type) {
        switch (match.params.type) {
            case 'always_touch':
                Component = AlwaysTouchOffers;
                break;
            case 'contact-less':
                Component = ContactLess;
                break;
            case 'mc-gifts':
                Component = McGifts;
                break;
            case 'ATB_offer':
                Component = HappyATB;
                break;
            case 'sunny_tariff':
                Component = UnderSunAquiring;
                break;
            case 'double_salary':
                Component = DoubleSalary;
                break;
            case 'united_country':
                Component = UnitedCountry;
                break;
        }
    } else {
        Component = OffersList;
    }

    return (
        <div className="module-business">
            <Component {...this.props} />
        </div>
    );
}
